import { Create } from 'react-admin'

import AiBooksForm from './AiBooksForm'

const AiBooksCreate = props => (
  <Create redirect="list" {...props}>
    <AiBooksForm isCreating />
  </Create>
)

export default AiBooksCreate
